import { AspAgingSummary, AspSummaryRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspInvoicesSummary() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  // One summary per currency with open items, sorted by currency.
  const [summaries, setSummaries] = useState<AspAgingSummary[]>([]);

  async function fetchAspInvoicesSummary(params: AspSummaryRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspInvoicesSummary(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setSummaries(res.Summaries);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, summaries, fetchAspInvoicesSummary };
}
